// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2eLq4","selected":"Chip_selected__2GvqW"};